import React from 'react';
import {Button} from "@/components/ui/button";
import {variantButtons} from "@/components/interfaces/global-interfaces";
import Link from "next/link";

function MediumButton({title, variant, customClass, href, children, ...props}: variantButtons) {
    return (
        <> {href ?
            (<Link href={href}>
                    <Button {...props} variant={variant}
                            className={` text-sm md:text-base h-[38px] md:h-[48px]  rounded-xl  active:scale-95 transition ${customClass}`}>
                        {title} {children}

                    </Button>

                </Link>
            ) : (
                <Button {...props} variant={variant}
                        className={` text-sm md:text-base h-[38px] md:h-[48px]  rounded-xl  active:scale-95 transition ${customClass}`}>
                    {title} {children}
                </Button>
            )
        }

        </>
    );
}

export default MediumButton;